// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import "./DetailLaunchParatha.css";

// /* ------------------------------------------------------------------
//    PRODUCT DATA (static)
//    Key = wahi id jo LaunchParatha ke PRODUCTS mein hai (ln-1, ln-2 ...)
//    - images: gallery ki images. Pehli 2 tumhari existing /img/ wali hain,
//      baaki 3 abhi placeholder hain. Apni images /img/ mein rakhkar
//      yahan path badal dena (jitni chaho utni add kar sakti ho).
//    - Naam/price LaunchParatha jaisa hi rakha hai. Dono jagah sync rakhna.
// ------------------------------------------------------------------- */
// const ph = (label, n, hex) =>
//   `https://placehold.co/900x1200/${hex}/fffbf7?text=${encodeURIComponent(label)}+${n}`;

// const PRODUCT_DETAILS = {
//   "ln-1": {
//     name: "Shabnam Cotton Silk Saree",
//     price: 3999,
//     oldPrice: 5950,
//     fabric: "Cotton Silk",
//     images: [
//       "/img/scrollsec3.webp",
//       "/img/scrollsec4.webp",
//       ph("Shabnam", 3, "6f9bb0"),
//       ph("Shabnam", 4, "557f94"),
//       ph("Shabnam", 5, "3d6478"),
//     ],
//   },
//   "ln-2": {
//     name: "Ruhira Maheshwari Cotton Saree",
//     price: 3850,
//     oldPrice: 5549,
//     fabric: "Maheshwari Cotton",
//     images: [
//       "/img/scrollsec1.webp",
//       "/img/scrollsec2.webp",
//       ph("Ruhira", 3, "a3345f"),
//       ph("Ruhira", 4, "852649"),
//       ph("Ruhira", 5, "671c38"),
//     ],
//   },
//   "ln-3": {
//     name: "Gulmohar Maheshwari Cotton Silk Saree",
//     price: 3899,
//     oldPrice: 5500,
//     fabric: "Maheshwari Cotton Silk",
//     images: [
//       "/img/scrollsec5.webp",
//       "/img/scrollsec6.webp",
//       ph("Gulmohar", 3, "8fb34a"),
//       ph("Gulmohar", 4, "779a35"),
//       ph("Gulmohar", 5, "5f7f27"),
//     ],
//   },
//   "ln-4": {
//     name: "Nazrana Maheshwari Cotton Silk Saree",
//     price: 3899,
//     oldPrice: 5500,
//     fabric: "Maheshwari Cotton Silk",
//     images: [
//       "/img/scrollsec7.webp",
//       "/img/scrollsec8.webp",
//       ph("Nazrana", 3, "3d5a9a"),
//       ph("Nazrana", 4, "2c4478"),
//       ph("Nazrana", 5, "1f3156"),
//     ],
//   },
//   "ln-5": {
//     name: "Gulrang Maheshwari Cotton Silk Saree",
//     price: 3899,
//     oldPrice: 5500,
//     fabric: "Maheshwari Cotton Silk",
//     images: [
//       "/img/scrollsec9.webp",
//       "/img/scrollsec10.webp",
//       ph("Gulrang", 3, "c4572f"),
//       ph("Gulrang", 4, "a64522"),
//       ph("Gulrang", 5, "86361a"),
//     ],
//   },
// };

// /* Offer line (sab products par same) */
// const OFFER_TITLE = "Festive Offer:";
// const OFFER_TEXT = "Buy 1 Get 1 Free. Limited Period";

// /* Badges (price ke neeche) */
// const BADGES = ["Breathable", "Premium", "Artisanal"];

// /* Accordion (neeche wale sections) - content apne hisaab se badal lena */
// const ACCORDION = [
//   {
//     title: "Wash Care",
//     content:
//       "Dry clean recommended for the first wash. Hand wash separately in cold water with a mild detergent. Do not wring or bleach. Dry in shade and iron on low heat.",
//   },
//   {
//     title: "Shipping",
//     content:
//       "Free pan-India shipping on prepaid orders. Orders are dispatched within 2-3 working days and usually delivered in 5-7 working days.",
//   },
//   {
//     title: "Disclaimer",
//     content:
//       "Slight colour variations may occur due to photography and screen settings. Minor irregularities are a natural characteristic of handwoven fabric.",
//   },
//   {
//     title: "Our Promise",
//     content:
//       "Every saree is quality checked and sourced directly from artisans. Easy returns and secure payments on every order.",
//   },
// ];

// const formatPrice = (value) =>
//   `Rs. ${Number(value).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   })}`;

// /* ---------------------------- ICONS ---------------------------- */
// const MinusIcon = () => (
//   <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
//     <path d="M5 12h14" />
//   </svg>
// );

// const PlusIcon = () => (
//   <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
//     <path d="M12 5v14M5 12h14" />
//   </svg>
// );

// const ChevronDown = () => (
//   <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//     <path d="M6 9l6 6 6-6" />
//   </svg>
// );

// /* Badge icons: olive circle ke andar safed line icon */
// const BadgeIcon = ({ name }) => {
//   const paths = {
//     Breathable: (
//       <>
//         <path d="M4 9h9a2.5 2.5 0 1 0-2.5-2.5" />
//         <path d="M4 13h13a2.5 2.5 0 1 1-2.5 2.5" />
//         <path d="M4 17h6" />
//       </>
//     ),
//     Premium: (
//       <>
//         <path d="M6 4h12l3 5-9 11L3 9l3-5z" />
//         <path d="M3 9h18M9 4l-2 5 5 11 5-11-2-5" />
//       </>
//     ),
//     Artisanal: (
//       <>
//         <circle cx="12" cy="12" r="7" />
//         <path d="M8 10c3-2 5 2 8 0M8 14c3-2 5 2 8 0" />
//       </>
//     ),
//   };

//   return (
//     <span className="detaillaunchparatha-badge-icon">
//       <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//         {paths[name]}
//       </svg>
//     </span>
//   );
// };

// /* --------------------------- COMPONENT -------------------------- */
// const DetailLaunchParatha = () => {
//   const { id } = useParams();
//   const product = PRODUCT_DETAILS[id];

//   const [activeImage, setActiveImage] = useState(0);
//   const [qty, setQty] = useState(1);
//   const [openAccordion, setOpenAccordion] = useState(null);

//   const galleryRef = useRef(null);
//   const imageRefs = useRef([]);

//   const isMobileView = () => window.matchMedia("(max-width: 900px)").matches;

//   /* Naye product par page upar se shuru */
//   useEffect(() => {
//     window.scrollTo(0, 0);
//     setActiveImage(0);
//     setQty(1);
//     setOpenAccordion(null);
//   }, [id]);

//   /* Desktop: scroll karte waqt jo image screen ke beech mein ho, wahi thumbnail active */
//   useEffect(() => {
//     if (!product) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (isMobileView()) return;
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const index = Number(entry.target.dataset.index);
//             setActiveImage(index);
//           }
//         });
//       },
//       { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
//     );

//     imageRefs.current.forEach((el) => el && observer.observe(el));
//     return () => observer.disconnect();
//   }, [product, id]);

//   /* Mobile: swipe karne par active image */
//   const handleGalleryScroll = useCallback(() => {
//     if (!isMobileView()) return;
//     const el = galleryRef.current;
//     if (!el || !el.clientWidth) return;
//     setActiveImage(Math.round(el.scrollLeft / el.clientWidth));
//   }, []);

//   /* Thumbnail / dot click */
//   const goToImage = (index) => {
//     if (isMobileView()) {
//       const el = galleryRef.current;
//       if (el) el.scrollTo({ left: index * el.clientWidth, behavior: "smooth" });
//     } else {
//       const target = imageRefs.current[index];
//       if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
//     }
//     setActiveImage(index);
//   };

//   const changeQty = (delta) => {
//     setQty((prev) => Math.min(10, Math.max(1, prev + delta)));
//   };

//   /* Real cart API se jodna ho to yahan apna add-to-cart call laga dena */
//   const handleAddToCart = () => {
//     toast.success(`${qty} x ${product.name} added to cart`);
//   };

//   if (!product) {
//     return (
//       <section className="detaillaunchparatha-section">
//         <div className="detaillaunchparatha-notfound">
//           <h2>Product not found</h2>
//           <Link to="/" className="detaillaunchparatha-back">
//             Back to home
//           </Link>
//         </div>
//       </section>
//     );
//   }

//   const detailLines = [
//     { label: "Product Type", value: "Saree" },
//     { label: "Fabric", value: product.fabric },
//     { label: "Length", value: "5.5 metres + 0.8 metre unstitched blouse piece" },
//     { label: "Craft", value: "Handwoven by Indian artisans" },
//   ];

//   return (
//     <section className="detaillaunchparatha-section">
//       <div className="detaillaunchparatha-layout">
//         {/* ---------------- THUMBNAILS (desktop) ---------------- */}
//         <div className="detaillaunchparatha-thumbs" role="tablist" aria-label="Product images">
//           {product.images.map((src, index) => (
//             <button
//               key={index}
//               type="button"
//               role="tab"
//               aria-selected={activeImage === index}
//               aria-label={`Show image ${index + 1}`}
//               className={`detaillaunchparatha-thumb ${
//                 activeImage === index ? "detaillaunchparatha-thumb-active" : ""
//               }`}
//               onClick={() => goToImage(index)}
//             >
//               <img src={src} alt="" draggable={false} />
//             </button>
//           ))}
//         </div>

//         {/* ---------------- GALLERY ---------------- */}
//         <div className="detaillaunchparatha-gallery-wrap">
//           <div
//             className="detaillaunchparatha-gallery"
//             ref={galleryRef}
//             onScroll={handleGalleryScroll}
//           >
//             {product.images.map((src, index) => (
//               <img
//                 key={index}
//                 ref={(el) => (imageRefs.current[index] = el)}
//                 data-index={index}
//                 src={src}
//                 alt={`${product.name} ${index + 1}`}
//                 className="detaillaunchparatha-image"
//                 loading={index === 0 ? "eager" : "lazy"}
//                 draggable={false}
//               />
//             ))}
//           </div>

//           {/* Mobile: dots */}
//           <div className="detaillaunchparatha-dots">
//             {product.images.map((_, index) => (
//               <button
//                 key={index}
//                 type="button"
//                 aria-label={`Show image ${index + 1}`}
//                 className={`detaillaunchparatha-dot ${
//                   activeImage === index ? "detaillaunchparatha-dot-active" : ""
//                 }`}
//                 onClick={() => goToImage(index)}
//               />
//             ))}
//           </div>
//         </div>

//         {/* ---------------- INFO ---------------- */}
//         <div className="detaillaunchparatha-info">
//           <h1 className="detaillaunchparatha-title">{product.name}</h1>

//           <p className="detaillaunchparatha-price">
//             <span>{formatPrice(product.price)}</span>
//             <s>{formatPrice(product.oldPrice)}</s>
//           </p>

//           <div className="detaillaunchparatha-offer">
//             <strong>{OFFER_TITLE}</strong>
//             <p>{OFFER_TEXT}</p>
//           </div>

//           <div className="detaillaunchparatha-qty" aria-label="Quantity">
//             <button type="button" aria-label="Decrease quantity" onClick={() => changeQty(-1)}>
//               <MinusIcon />
//             </button>
//             <span>{qty}</span>
//             <button type="button" aria-label="Increase quantity" onClick={() => changeQty(1)}>
//               <PlusIcon />
//             </button>
//           </div>

//           <button
//             type="button"
//             className="detaillaunchparatha-cart-btn"
//             onClick={handleAddToCart}
//           >
//             Add to cart
//           </button>

//           <div className="detaillaunchparatha-badges">
//             {BADGES.map((badge) => (
//               <span className="detaillaunchparatha-badge" key={badge}>
//                 <BadgeIcon name={badge} />
//                 {badge}
//               </span>
//             ))}
//           </div>

//           <div className="detaillaunchparatha-details">
//             {detailLines.map((line) => (
//               <p key={line.label}>
//                 <strong>{line.label}:</strong> {line.value}
//               </p>
//             ))}
//           </div>

//           <div className="detaillaunchparatha-accordion">
//             {ACCORDION.map((item, index) => {
//               const isOpen = openAccordion === index;
//               return (
//                 <div
//                   key={item.title}
//                   className={`detaillaunchparatha-acc-item ${
//                     isOpen ? "detaillaunchparatha-acc-open" : ""
//                   }`}
//                 >
//                   <button
//                     type="button"
//                     className="detaillaunchparatha-acc-head"
//                     aria-expanded={isOpen}
//                     onClick={() => setOpenAccordion(isOpen ? null : index)}
//                   >
//                     <span>{item.title}</span>
//                     <ChevronDown />
//                   </button>

//                   <div className="detaillaunchparatha-acc-body">
//                     <div className="detaillaunchparatha-acc-inner">
//                       <p>{item.content}</p>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default DetailLaunchParatha;














// 04-11-2026 Dynamic code
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import "./DetailLaunchParatha.css";

const Z_API = "https://cyberathon.com/streekatha/API/index.php/Master_controller";

const OFFER_TITLE = "Festive Offer:";
const OFFER_TEXT = "Buy 1 Get 1 Free. Limited Period";
const BADGES = ["Breathable", "Premium", "Artisanal"];

const ACCORDION = [
  { title: "Wash Care", content: "Dry clean recommended for the first wash. Hand wash separately in cold water with a mild detergent. Do not wring or bleach. Dry in shade and iron on low heat." },
  { title: "Shipping", content: "Free pan-India shipping on prepaid orders. Orders are dispatched within 2-3 working days and usually delivered in 5-7 working days." },
  { title: "Disclaimer", content: "Slight colour variations may occur due to photography and screen settings. Minor irregularities are a natural characteristic of handwoven fabric." },
  { title: "Our Promise", content: "Every saree is quality checked and sourced directly from artisans. Easy returns and secure payments on every order." },
];

const formatPrice = (value) =>
  `Rs. ${Number(value).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const MinusIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true"><path d="M5 12h14" /></svg>
);
const PlusIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
);
const ChevronDown = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
);

const BadgeIcon = ({ name }) => {
  const paths = {
    Breathable: (<><path d="M4 9h9a2.5 2.5 0 1 0-2.5-2.5" /><path d="M4 13h13a2.5 2.5 0 1 1-2.5 2.5" /><path d="M4 17h6" /></>),
    Premium: (<><path d="M6 4h12l3 5-9 11L3 9l3-5z" /><path d="M3 9h18M9 4l-2 5 5 11 5-11-2-5" /></>),
    Artisanal: (<><circle cx="12" cy="12" r="7" /><path d="M8 10c3-2 5 2 8 0M8 14c3-2 5 2 8 0" /></>),
  };
  return (
    <span className="detaillaunchparatha-badge-icon">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {paths[name]}
      </svg>
    </span>
  );
};

const DetailLaunchParatha = () => {
  const { slug } = useParams();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImage, setActiveImage] = useState(0);
  const [qty, setQty] = useState(1);
  const [openAccordion, setOpenAccordion] = useState(null);

  const galleryRef = useRef(null);
  const imageRefs = useRef([]);

  const isMobileView = () => window.matchMedia("(max-width: 900px)").matches;

  /* API se product */
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setProduct(null);

    axios
      .get(`${Z_API}/get_z_product_detail`, { params: { slug } })
      .then((res) => {
        if (cancelled) return;
        if (res.data.status === "true" && res.data.data) {
          const d = res.data.data;
          setProduct({
            id: d.id,
            name: d.name,
            price: Number(d.current_price),
            oldPrice: Number(d.old_price),
            fabric: d.fabric,
            productType: d.product_type,
            length: d.length_info,
            craft: d.craft,
            description: d.description,
            images: Array.isArray(d.images) ? d.images : [],
          });
        }
      })
      .catch(() => {})
      .finally(() => !cancelled && setLoading(false));

    return () => { cancelled = true; };
  }, [slug]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setActiveImage(0);
    setQty(1);
    setOpenAccordion(null);
  }, [slug]);

  useEffect(() => {
    if (!product) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (isMobileView()) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveImage(Number(entry.target.dataset.index));
        });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
    );
    imageRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [product, slug]);

  const handleGalleryScroll = useCallback(() => {
    if (!isMobileView()) return;
    const el = galleryRef.current;
    if (!el || !el.clientWidth) return;
    setActiveImage(Math.round(el.scrollLeft / el.clientWidth));
  }, []);

  const goToImage = (index) => {
    if (isMobileView()) {
      const el = galleryRef.current;
      if (el) el.scrollTo({ left: index * el.clientWidth, behavior: "smooth" });
    } else {
      const target = imageRefs.current[index];
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setActiveImage(index);
  };

  const changeQty = (delta) => setQty((prev) => Math.min(10, Math.max(1, prev + delta)));

  const handleAddToCart = () => {
    toast.success(`${qty} x ${product.name} added to cart`);
  };

  if (loading) {
    return (
      <section className="detaillaunchparatha-section">
        <p style={{ textAlign: "center", padding: "80px 0" }}>Loading...</p>
      </section>
    );
  }

  if (!product) {
    return (
      <section className="detaillaunchparatha-section">
        <div className="detaillaunchparatha-notfound">
          <h2>Product not found</h2>
          <Link to="/" className="detaillaunchparatha-back">Back to home</Link>
        </div>
      </section>
    );
  }

  const detailLines = [
    { label: "Product Type", value: product.productType },
    { label: "Fabric", value: product.fabric },
    { label: "Length", value: product.length },
    { label: "Craft", value: product.craft },
  ].filter((l) => l.value);

  return (
    <section className="detaillaunchparatha-section">
      <div className="detaillaunchparatha-layout">
        <div className="detaillaunchparatha-thumbs" role="tablist" aria-label="Product images">
          {product.images.map((src, index) => (
            <button
              key={index}
              type="button"
              role="tab"
              aria-selected={activeImage === index}
              aria-label={`Show image ${index + 1}`}
              className={`detaillaunchparatha-thumb ${activeImage === index ? "detaillaunchparatha-thumb-active" : ""}`}
              onClick={() => goToImage(index)}
            >
              <img src={src} alt="" draggable={false} />
            </button>
          ))}
        </div>

        <div className="detaillaunchparatha-gallery-wrap">
          <div className="detaillaunchparatha-gallery" ref={galleryRef} onScroll={handleGalleryScroll}>
            {product.images.map((src, index) => (
              <img
                key={index}
                ref={(el) => (imageRefs.current[index] = el)}
                data-index={index}
                src={src}
                alt={`${product.name} ${index + 1}`}
                className="detaillaunchparatha-image"
                loading={index === 0 ? "eager" : "lazy"}
                draggable={false}
              />
            ))}
          </div>

          <div className="detaillaunchparatha-dots">
            {product.images.map((_, index) => (
              <button
                key={index}
                type="button"
                aria-label={`Show image ${index + 1}`}
                className={`detaillaunchparatha-dot ${activeImage === index ? "detaillaunchparatha-dot-active" : ""}`}
                onClick={() => goToImage(index)}
              />
            ))}
          </div>
        </div>

        <div className="detaillaunchparatha-info">
          <h1 className="detaillaunchparatha-title">{product.name}</h1>

          <p className="detaillaunchparatha-price">
            <span>{formatPrice(product.price)}</span>
            {product.oldPrice > product.price && <s>{formatPrice(product.oldPrice)}</s>}
          </p>

          <div className="detaillaunchparatha-offer">
            <strong>{OFFER_TITLE}</strong>
            <p>{OFFER_TEXT}</p>
          </div>

          <div className="detaillaunchparatha-qty" aria-label="Quantity">
            <button type="button" aria-label="Decrease quantity" onClick={() => changeQty(-1)}><MinusIcon /></button>
            <span>{qty}</span>
            <button type="button" aria-label="Increase quantity" onClick={() => changeQty(1)}><PlusIcon /></button>
          </div>

          <button type="button" className="detaillaunchparatha-cart-btn" onClick={handleAddToCart}>
            Add to cart
          </button>

          <div className="detaillaunchparatha-badges">
            {BADGES.map((badge) => (
              <span className="detaillaunchparatha-badge" key={badge}>
                <BadgeIcon name={badge} />
                {badge}
              </span>
            ))}
          </div>

          <div className="detaillaunchparatha-details">
            {detailLines.map((line) => (
              <p key={line.label}><strong>{line.label}:</strong> {line.value}</p>
            ))}
            {product.description && <p>{product.description}</p>}
          </div>

          <div className="detaillaunchparatha-accordion">
            {ACCORDION.map((item, index) => {
              const isOpen = openAccordion === index;
              return (
                <div key={item.title} className={`detaillaunchparatha-acc-item ${isOpen ? "detaillaunchparatha-acc-open" : ""}`}>
                  <button
                    type="button"
                    className="detaillaunchparatha-acc-head"
                    aria-expanded={isOpen}
                    onClick={() => setOpenAccordion(isOpen ? null : index)}
                  >
                    <span>{item.title}</span>
                    <ChevronDown />
                  </button>
                  <div className="detaillaunchparatha-acc-body">
                    <div className="detaillaunchparatha-acc-inner">
                      <p>{item.content}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DetailLaunchParatha;